import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ViewCustomerTable from "./ViewCustomerTable";
import InformationModal from "./InformationModal";
import * as Fa from "react-icons/fa";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { TabView, TabPanel } from "primereact/tabview";
import {
    createAPICustomerMastEndpoint,
    Endpoint,
} from "../../Services/CustomerMast/CustomerMastService";
// import { Dropdown } from "primereact/dropdown";
import storage from "../../Services/Storage";
import Loader from "../../Components/Loader";
import Axios from "../../api/Axios";
import { toast } from "react-toastify";
function ViewCustomer() {
    const nav = useNavigate();
    const auth = storage.getLocal("user");
    const [splCustPopup, setSplCustPopup] = useState(false);
    const [loadingdt, setLoadingdt] = useState(false);
    const [loading, setLoading] = useState(false);
    const [excelLoading, setExcelLoading] = useState(false);
    const [dnaCustList, setDnaCustList] = useState([]);
    const [rblmtataessrCustList, setRblmtataessrCustList] = useState([]);
    const [mobileverifiedCust, setMobileverifiedCust] = useState([]);
    const [rseProspcust, setRseProspcust] = useState([]);
    const [gSTverifiedCust, setGSTverifiedCust] = useState([]);
    const [exportbtnpopup, setExportbtnpopup] = useState(false);
    const [AllCustData, setAllCustData] = useState([]);

    const newCust = () => {
        nav("/masters/customermaster/details?custType=newcust");
    };
    // const nav = useNavigate();

    const renderActionDNA = (rowData) => {
        return (
            <>
                <div className="action-icon">
                    <div
                        className="d-inline"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="View/Edit Customer Details"
                    >
                        <button
                            className="grid-icon-img"
                            onClick={() => {
                                nav(
                                    `/masters/customermaster/details?dnaId=${rowData.DNAID}&custType=DNA`
                                );
                            }}
                        >
                            <img
                                alt="InnoRise"
                                width="20px"
                                src={require("../../Assets/Images/ViewEdit.png")}
                            />
                        </button>
                    </div>
                </div>
            </>
        );
    };
    const renderActionRSE = (rowData) => {
        return (
            <>
                <div className="action-icon">
                    <div
                        className="d-inline"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="View/Edit Customer Details"
                    >
                        <button
                            className="grid-icon-img"
                            onClick={() => {
                                nav(
                                    `/masters/customermaster/details?dnaId=${rowData.DNAID}&custType=DNA&reseType=RSE`
                                );
                            }}
                        >
                            <img
                                alt="InnoRise"
                                width="20px"
                                src={require("../../Assets/Images/ViewEdit.png")}
                            />
                        </button>
                    </div>
                </div>
            </>
        );
    };
    const ActionRLIESSR = (rowData) => {
        return (
            <>
                <div className="action-icon">
                    <div
                        className="d-inline"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="View/Edit Customer Details"
                    >
                        <button
                            className="grid-icon-img"
                            onClick={() => {
                                nav(
                                    `/masters/customermaster/details?essrrliID=${rowData.DB_CODE},${rowData.ID}&custType=RLIESSR`
                                );
                            }}
                        >
                            <img
                                alt="InnoRise"
                                width="20px"
                                src={require("../../Assets/Images/ViewEdit.png")}
                            />
                        </button>
                    </div>
                </div>
            </>
        );
    };
    const ActionGSTCUST = (rowData) => {
        // console.log(rowData);
        // return;
        return (
            <>
                <div className="action-icon">
                    <div
                        className="d-inline"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="View/Edit Customer Details"
                    >
                        <button
                            className="grid-icon-img"
                            onClick={() => {
                                nav(
                                    `/masters/customermaster/details?gstcustId=${rowData.CustomerID}&custType=Gstvcust&rowdatagst=${JSON.stringify(rowData)}&gstcustcode=${rowData.CUSTOMER_CODE}&ismobcust=N`
                                );
                            }}
                        >
                            <img
                                alt="InnoRise"
                                width="20px"
                                src={require("../../Assets/Images/ViewEdit.png")}
                            />
                        </button>
                        <button
                            className="grid-icon"
                            onClick={() => {
                                updateGSTverify(rowData);
                            }}
                        >
                            <Fa.FaTrashAlt className="cancel" />
                        </button>
                    </div>
                </div>
            </>
        );
    };
    const ActionMOBverifiedCUST = (rowData) => {
        return (
            <>
                <div className="action-icon">
                    <div
                        className="d-inline"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="View/Edit Customer Details"
                    >
                        <button
                            className="grid-icon-img"
                            onClick={() => {
                                nav(
                                    `/masters/customermaster/details?gstcustId=${rowData.CustomerID}&custType=Gstvcust&rowdatagst=${JSON.stringify(rowData)}&gstcustcode=${rowData.CUSTOMER_CODE}&ismobcust=Y`
                                );
                            }}
                        >
                            <img
                                alt="InnoRise"
                                width="20px"
                                src={require("../../Assets/Images/ViewEdit.png")}
                            />
                        </button>
                        <button
                            className="grid-icon"
                            onClick={() => {
                                updateMobileVerified(rowData);
                            }}
                        >
                            <Fa.FaTrashAlt className="cancel" />
                        </button>
                    </div>
                </div>
            </>
        );
    };

    const updateGSTverify = async(rowdata) => {
        // console.log(rowdata);
        let Payload ={
            compId: auth.CompId,
            custCode: rowdata.CUSTOMER_CODE,
            parentId: rowdata.PARENT_ID,
            strStatus:"R",
        };
        //   return;
        try {
            setLoadingdt(true);
            let postURL = "CustomerMast/SaveStatusExistCustForGST?";
            let dataresponse = await Axios.post(postURL, JSON.stringify(Payload), {
                headers: { "Content-Type": "application/json" },
            });
            console.log(dataresponse?.data?.Messege);
            toast.success("Data removed successfully", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            GSTcustomerList();
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingdt(false);
        }
    };

    const updateMobileVerified =async (rowdata) => {
        // console.log("rowdata", rowdata);
        let Payload ={
            compId: auth.CompId,
            custCode: rowdata.CUSTOMER_CODE,
            parentId: rowdata.PARENT_ID,
            strStatus:"R",
        };
        //   return;
        try {
            setLoadingdt(true);
            let postURL = "CustomerMast/SaveVerifiedExistCustMobile";
            let dataresponse = await Axios.post(postURL, JSON.stringify(Payload), {
                headers: { "Content-Type": "application/json" },
            });
            console.log(dataresponse?.data?.Messege);
            toast.success("Data removed successfully", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            MobilecustomerList();
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingdt(false);
        }
    };

    const splCustomer = () => {
        setSplCustPopup(true);
    };
    useEffect(() => {
        customerList();
        DNAcustomerList();
        GSTcustomerList();
        MobilecustomerList();
        DNARsecustomerList();
    }, []);

    const exportdata = () => {
        setExportbtnpopup(true);
    };

    const customerList = () => {
        setLoading(true);
        createAPICustomerMastEndpoint()
            .get(
                `${Endpoint.GetRILCustomers}?CICode=${auth.CICode}&CompId=${auth.CompId}`
            )
            .then((response) => {
                setRblmtataessrCustList(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };
    const GSTcustomerList = () => {
        setLoading(true);
        createAPICustomerMastEndpoint()
            .get(`${Endpoint.PopulateGSTExistCustList}?CompId=${auth.CompId}`)
            .then((response) => {
                setGSTverifiedCust(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };
    const MobilecustomerList = () => {
        setLoading(true);
        createAPICustomerMastEndpoint()
            .get(`${Endpoint.PopulateMobileExistCustList}?CompId=${auth.CompId}`)
            .then((response) => {
                setMobileverifiedCust(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };
    const DNAcustomerList = () => {
        setLoading(true);
        createAPICustomerMastEndpoint()
            .get(
                `${Endpoint.GetAwaitedDNAList}?DBID=${auth.CompId}&Status=Awaiting DB Confirmation`
            )
            .then((response) => {
                setDnaCustList(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };
    const DNARsecustomerList = () => {
        setLoading(true);
        createAPICustomerMastEndpoint()
            .get(
                `${Endpoint.GetUrbanList}?DBID=${auth.CompId}`
            )
            .then((response) => {
                setRseProspcust(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };

    const getAllCustomers = async () => {
        setLoading(true);

        createAPICustomerMastEndpoint()
            .get(
                `${Endpoint.GetAllCustomer}?CICode=${auth.CICode}&CompId=${auth.CompId}`
            )
            .then((response) => {
                setAllCustData(response.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        getAllCustomers();
    }, []);

    const renderAction = (rowData) => {
        return (
            <>
                <div className="action-icon">
                    <div
                        className="d-inline"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="View/Edit Customer Details"
                    >
                        <button
                            className="grid-icon-img"
                            onClick={() => {
                                nav(
                                    `/masters/customermaster/details?maskCustId=${encodeURIComponent(rowData.MASK_CUST_ID)}&partyCode=${encodeURIComponent(rowData.PARTY_CODE)}&custType=normal`
                                );
                            }}
                        >
                            <img
                                alt="InnoRise"
                                width="20px"
                                src={require("../../Assets/Images/ViewEdit.png")}
                            />
                        </button>
                    </div>
                </div>
            </>
        );
    };

    if (loading) {
        return <Loader />;
    } else {
        return (
            <>
                <main>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <h3 className="py-2">Customer Master</h3>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="float-end mb-2">
                                {auth.DB_TYPE!=="E1A:B2C"&&<button
                                    type="submit"
                                    className="btn btn-outline-primary me-3"
                                    onClick={newCust}
                                >
                  Add New Customer
                                </button>}
                                <button
                                    type="submit"
                                    className="btn btn-primary me-3"
                                    onClick={exportdata}
                                    disabled={excelLoading}
                                >
                                    {excelLoading ? "Loading..." : "Export All"}{" "}
                                    {excelLoading ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <Fa.FaFileExport className="ms-2" />
                                    )}
                                </button>
                                {auth.DistTag !== "I" && (
                                    <button
                                        type="submit"
                                        className={
                                            dnaCustList?.length > 0 || rblmtataessrCustList?.length > 0||mobileverifiedCust?.length>0 ||gSTverifiedCust?.length>0
                                                ? ""
                                                : "btn btn-primary"
                                        }
                                        onClick={splCustomer}
                                        id={
                                            dnaCustList.length > 0 || rblmtataessrCustList.length > 0||mobileverifiedCust?.length>0 ||gSTverifiedCust?.length>0
                                                ? "blinking-button"
                                                : ""
                                        }
                                    >
                    Prospect Customer
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                    <ViewCustomerTable
                        renderAction={renderAction}
                        AllCustData={AllCustData}
                    />
                </main>
                <InformationModal
                    exportbtnpopup={exportbtnpopup}
                    setExportbtnpopup={setExportbtnpopup}
                    setExcelLoading={setExcelLoading}
                />
                <Dialog
                    header="Prospect Customer List"
                    visible={splCustPopup}
                    maximizable
                    style={{ width: "80vw" }}
                    draggable={false}
                    onHide={() => {
                        setSplCustPopup(false);
                    }}
                >
                    <div className="TabPanel">
                        <TabView>
                            <TabPanel header="DNA List">
                                <div className="DataTable">
                                    <DataTable
                                        value={dnaCustList}
                                        paginator
                                        rows={10}
                                        filterDisplay="row"
                                        scrollable
                                        rowsPerPageOptions={[10, 25, 50]}
                                        scrollHeight="80vh"
                                        // showGridlines
                                        stripedRows
                                        emptyMessage="No customers found."
                                        tableStyle={{ minWidth: "80rem" }}
                                    >
                                        <Column
                                            field="DealerName"
                                            header="Customer Name"
                                            style={{ minWidth: "12rem" }}
                                            filterMatchMode="contains"
                                            filter
                                            filterPlaceholder="Search Here..."
                                        />
                                        <Column
                                            field="OwnerMobileNo"
                                            header="Owner Mobile No"
                                            style={{ minWidth: "12rem" }}
                                            filterMatchMode="contains"
                                            filter
                                            filterPlaceholder="Search Here..."
                                        />
                                        <Column field="SubSegmentDesc" header="Segment" />
                                        <Column body={(rowdata)=> rowdata.OwnerMobileNumberStatus=="V"?"Verified":null} header="Status" />
                                        <Column field={renderActionDNA} header="Action" />
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel header="Urban Service Customer List">
                                <div className="DataTable">
                                    <DataTable
                                        value={rseProspcust}
                                        paginator
                                        rows={10}
                                        filterDisplay="row"
                                        scrollable
                                        rowsPerPageOptions={[10, 25, 50]}
                                        scrollHeight="80vh"
                                        stripedRows
                                        emptyMessage="No customers found."
                                        tableStyle={{ minWidth: "80rem" }}
                                    >
                                        <Column
                                            field="OutletName"
                                            header="Customer Name"
                                            style={{ minWidth: "12rem" }}
                                            filterMatchMode="contains"
                                            filter
                                            filterPlaceholder="Search Here..."
                                        />
                                        <Column
                                            field="OwnerMobileNo"
                                            header="Owner Mobile No"
                                            style={{ minWidth: "12rem" }}
                                            filterMatchMode="contains"
                                            filter
                                            filterPlaceholder="Search Here..."
                                        />
                                        <Column field="SubSegmentDesc" header="Segment" />
                                        <Column field={renderActionRSE} header="Action" />
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel header="RBML/TATA/ESSAR Segment Customer">
                                <div className="DataTable">
                                    <DataTable
                                        value={rblmtataessrCustList}
                                        paginator
                                        rows={10}
                                        filterDisplay="row"
                                        scrollable
                                        rowsPerPageOptions={[10, 25, 50]}
                                        scrollHeight="80vh"
                                        // showGridlines
                                        stripedRows
                                        emptyMessage="No customers found."
                                        tableStyle={{ minWidth: "80rem" }}
                                    >
                                        <Column
                                            field="CUST_NAME"
                                            header="Customer Name"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                            style={{ minWidth: "12rem" }}
                                        />
                                        <Column
                                            field="MOBILE"
                                            header="Mobile No"
                                            style={{ minWidth: "12rem" }}
                                            filterMatchMode="contains"
                                            filter
                                            filterPlaceholder="Search Here..."
                                        />
                                        <Column field="SEG_CODE" header="Segment Code" />
                                        <Column field="SEG_NAME" header="Segment Name" />
                                        <Column field={ActionRLIESSR} header="Action" />
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel header="GST Verified Customer">
                                <div className="DataTable">
                                    <DataTable
                                        value={gSTverifiedCust}
                                        paginator
                                        rows={10}
                                        filterDisplay="row"
                                        scrollable
                                        rowsPerPageOptions={[10, 25, 50]}
                                        scrollHeight="80vh"
                                        stripedRows
                                        emptyMessage="No customers found."
                                        tableStyle={{ minWidth: "80rem" }}
                                    >
                                        <Column
                                            field="CUSTOMER_CODE"
                                            header="Customer Code"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                            style={{ minWidth: "12rem" }}
                                        />
                                        <Column
                                            field="CUSTOMER_NAME"
                                            header="Customer Name"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                            style={{ minWidth: "12rem" }}
                                        />
                                        <Column
                                            field="PARENT_ID"
                                            header="Parent ID"
                                            style={{ minWidth: "12rem" }}
                                            filterMatchMode="contains"
                                            filter
                                            filterPlaceholder="Search Here..."
                                        />
                                        <Column
                                            field="SubSegmentID"
                                            header="Segment "
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        />
                                        <Column
                                            field="CUST_GST_NO"
                                            header="GST number"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        />
                                        <Column field={ActionGSTCUST} header="Action" />
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel header="Mobile Number Verified Customer">
                                <div className="DataTable">
                                    <DataTable
                                        value={mobileverifiedCust}
                                        paginator
                                        rows={10}
                                        filterDisplay="row"
                                        scrollable
                                        rowsPerPageOptions={[10, 25, 50]}
                                        scrollHeight="80vh"
                                        // showGridlines
                                        stripedRows
                                        emptyMessage="No customers found."
                                        tableStyle={{ minWidth: "80rem" }}
                                    >
                                        <Column
                                            field="CUSTOMER_CODE"
                                            header="Customer Code"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                            style={{ minWidth: "12rem" }}
                                        />
                                        <Column
                                            field="CUSTOMER_NAME"
                                            header="Customer Name"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                            style={{ minWidth: "12rem" }}
                                        />
                                        <Column
                                            field="PARENT_ID"
                                            header="Parent ID"
                                            style={{ minWidth: "12rem" }}
                                            filterMatchMode="contains"
                                            filter
                                            filterPlaceholder="Search Here..."
                                        />
                                        <Column
                                            field="SubSegmentID"
                                            header="Segment"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        />
                                        <Column
                                            field="CUST_MOBILE_NO"
                                            header="Mobile Number"
                                            filter
                                            filterMatchMode="contains"
                                            filterPlaceholder="Search Here..."
                                        />
                                        <Column field={ActionMOBverifiedCUST} header="Action" />
                                    </DataTable>
                                </div>
                            </TabPanel>
                        </TabView>
                    </div>
                </Dialog>
                {loadingdt?<><Loader/></>:null}
            </>
        );
    }
}

export default ViewCustomer;
